import { ChangeDetectionStrategy, Component, Input, OnChanges, inject } from '@angular/core';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { PICFLOW_STORYBLOK } from '../../../picflow-storyblok';
import { StoryblokComponentInstance } from '../../../services/storyblok.service';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-content-group',
  imports: [DynamicComponent, DynamicIoDirective, BlockWrapperComponent],
  templateUrl: './content-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentGroupComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() style: BlockStyle[];
  @Input() blocks: StoryblokComponentInstance[];
  @Input() alignBlocks: string;
  @Input() extraDataMap: Map<
    string,
    {
      [key: string]: unknown;
    }
  >;

  private storyblokService = inject(PICFLOW_STORYBLOK);
  components = this.storyblokService.components;

  ngOnChanges() {
    if (!this.style) {
      this.style = [];
    }
    this.style[0] = this.style[0] || <BlockStyle>{};
    this.style[0].alignLeftChildPages = this.alignBlocks === 'left';

    this.blocks.forEach(item => {
      if (!('style' in item)) return;
      if (!item.style) return;
      if (Array.isArray(item.style) && !item.style.length) {
        item.style = [{} as BlockStyle];
      }
      item.style[0].inWrapper = true;
    });
  }

  dynamicInputs(values: { [key: string]: unknown }) {
    const data = { ...values };
    const extraData = this.extraDataMap?.get((values as { component: string }).component);
    if (extraData) {
      for (const key of Object.keys(extraData)) data[key] = extraData[key];
    }
    return data;
  }
}
